import { SettingsField } from './SettingsField'
import type { AgentMeta } from './agentTypeMetadata'

interface Props {
  agent: AgentMeta
  settings: Record<string, unknown>
  onChange: (settings: Record<string, unknown>) => void
  campaignProductId?: number | null
}

export function SettingsForm({
  agent,
  settings,
  onChange,
  campaignProductId,
}: Props) {
  if (agent.settings_schema.length === 0) return null

  return (
    // Divider + top padding separates the agent-config section from the column
    // identity fields above it. Arbitrary pt so Bootstrap's !important .pt-*
    // scale utilities can't inflate it in the app shell.
    <div className="border-t border-fbui-gray-200 pt-[1.25rem]">
      <h4 className="text-xs font-medium uppercase tracking-wide text-fbui-gray-500">
        Agent Settings
      </h4>
      <div className="mt-3 space-y-4">
        {agent.settings_schema.map((field) => (
          <SettingsField
            key={field.key}
            field={field}
            value={settings[field.key]}
            onChange={(value) => onChange({ ...settings, [field.key]: value })}
            campaignProductId={campaignProductId}
          />
        ))}
      </div>
    </div>
  )
}
